// @flow
import CardMarks from './CardMarks';

export default CardMarks;
